import { UserProfile } from "../../../../types/api/users";
import { ClockIcon, DeviceMobileIcon, InfoIcon, MailIcon } from '@primer/octicons-react'

interface UserContactsProps {
    user: UserProfile
    className?: string;
}


const UserContacts: React.FC<UserContactsProps> = ({
    user,
    className
}) => {
    const formatDate = (date: string) => new Date(date).toLocaleDateString('ru-RU');

    const mainContacts = [
        { icon: ClockIcon, label: "Дата регистрации", value: formatDate(user.createdAt) },
        { icon: DeviceMobileIcon, label: "Телефон", value: user.phone, link: `tel:${user.phone}` },
        { icon: MailIcon, label: "E-mail", value: user.email, link: `mailto:${user.email}` },
        { icon: InfoIcon, label: "Идентификатор", value: user.number }
    ];

    const socialContacts = [
        { icon: "telegram", label: "Telegram", value: user.telegram },
        { icon: "whatsapp", label: "WhatsApp", value: user.whatsapp },
        { icon: "viber", label: "Viber", value: user.viber }
    ].filter(Boolean);

    const renderContactRow = (contact: any, index: number, isMainContact: boolean) => (
        <div key={index} className="flex items-center py-2">
            <div className="flex items-center gap-3 w-[160px] flex-shrink-0">
                {isMainContact ? (
                    <contact.icon className="w-5 h-5 text-gray-500 flex-shrink-0" />
                ) : (
                    <img
                        src={`/icons/${contact.icon}.png`}
                        alt="logo"
                        className="w-5 h-5 flex-shrink-0"
                    />
                )}
                <span className="text-[14px] text-aloix-black font-normal">
                    {contact.label}
                </span>
            </div>
            <div className="w-[36px] flex-shrink-0"></div>
            <span className="text-[14px] text-aloix-grey font-normal">
                {contact.value}
            </span>
        </div>
    );

    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${className}`}>
            <div className="space-y-4">
                {mainContacts.map((contact, index) =>
                    renderContactRow(contact, index, true)
                )}
            </div>

            {socialContacts.length > 0 && (
                <div className="space-y-4">
                    {socialContacts.map((contact, index) =>
                        renderContactRow(contact, index, false)
                    )}
                </div>
            )}
        </div>
    );
};

export default UserContacts